import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import axios from "./../services/http";
import { Breadcrumb, Layout, Button, Table, message, Tag, Tabs, Modal, Input, Form, Divider } from 'antd';
import { CheckCircleOutlined, WarningFilled, CloseCircleOutlined, EditOutlined, MinusOutlined } from '@ant-design/icons';
import { jwtDecode } from 'jwt-decode';
const { Content } = Layout;

const PaymentControlsToAuthorize = () => {

    const location = useLocation();
    const { from } = location.state;
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [listNotAuth, setListNotAuth] = useState([]);
    const [authInfo, setAuthInfo] = useState({ concepto: '' });
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [openDialog, setOpenDialog] = useState(false);

    useEffect(() => {
        GetPayments();
        GetPaymentsNotAuth();
    }, []);

    const GetPayments = async () => {
        try {
            const decoded = jwtDecode(localStorage.getItem("token"));
            const response = await axios.HTTP_POST('/api/v1/payments/list', {
                estatus: "POR AUTORIZAR",
                rol: decoded.privilegios,
                usuario: decoded.id
            });
            if (response && response.data) {
                for (let i = 0; i < response.data.length; i++) { response.data[i]["key"] = response.data[i].id; }
                setList(response.data);
            }
        } catch (e) {
            console.error('Error al obtener los controles de pago:', e);
            message.error('Hubo un error al obtener los controles de pago');
        }
    }

    const GetPaymentsNotAuth = async () => {
        try {
            const decoded = jwtDecode(localStorage.getItem("token"));
            const response = await axios.HTTP_POST('/api/v1/payments/list', {
                estatus: "NO AUTORIZADO",
                rol: decoded.privilegios,
                usuario: decoded.id
            });
            if (response && response.data) {
                for (let i = 0; i < response.data.length; i++) { response.data[i]["key"] = response.data[i].id; }
                setListNotAuth(response.data);
            }
        } catch (e) {
            console.error('Error al obtener los controles de pago:', e);
            message.error('Hubo un error al obtener los controles de pago');
        }
    }

    const QuitPayment = async (payment) => {
        try {
            const response = await axios.HTTP_POST('/api/v1/payments/remove-list-not-auth', payment);
            if (response && response.data) {
                message.success(`Control de Pago ${payment.concepto.toUpperCase()} se eliminó correctamente.`);
                GetPayments(); // Refrescar lista Por Autorizar
                GetPaymentsNotAuth(); // Refrescar lista No Autorizados
            }
        } catch (e) {
            console.error('Error al eliminar el control de pago:', e);
            message.error('Hubo un error al eliminar el control de pago');
        }
    }

    const handleUpdateAuth = async (values) => {
        console.log(values, authInfo)
        setLoading(true);
        let auth = {
            emailn1: values.emailn1,
            emailn2: values.emailn2,
            id_autorizacion: authInfo.id_autorizacion,
            id_control: authInfo.id,
            obra_nombre: authInfo.nombre_obra
        };
        const response = await axios.HTTP_POST("/api/v1/auth/cp-emails-auth/update", auth);
        if (response && response.data) {
            setOpenDialog(false);
            setLoading(false);
            message.success(response.data.message);
            GetPayments();
        }
    }

    const Navigate = (path, params) => {
        navigate(path, params);
    }

    const columns = [
        {
            title: 'Obra',
            dataIndex: 'obra',
            key: 'id',
            render: (_, payment) => {
                return (
                    <>
                        {
                            payment.estatus === "POR AUTORIZAR"
                                ?
                                <Link to={{ pathname: `/payment-control/${payment.id}` }} state={{ from: from }} >
                                    {payment.nombre_obra}
                                </Link>
                                :
                                <div>{payment.nombre_obra}</div>
                        }
                    </>
                );
            }
        },
        {
            title: 'Información General',
            dataIndex: 'concepto',
            key: 'concepto',
            render: ((_, payment) =>
                <>
                    <div>{payment.concepto}</div>
                    <div>{payment.descripcion}</div>
                </>
            )
        },
        {
            title: 'Presupuesto',
            dataIndex: 'presupuesto',
            key: 'presupuesto',
            render: ((_, payment) =>
                <>
                    <div><span style={{ fontWeight: 600 }}>TOTAL:</span> $ {payment.presupuesto}</div>
                    <div><span style={{ fontWeight: 600 }}>C/IVA:</span> {payment.presupuesto_iva}%</div>
                    <div><span style={{ fontWeight: 600 }}>S/IVA:</span> {payment.presupuesto_no_iva}%</div>
                </>
            )
        },
        {
            title: 'Autorización (Email´s)',
            dataIndex: 'autorizacion_n1',
            key: 'id_autorizacion',
            render: ((_, payment) =>
                <>
                    <div
                        style={{ display: 'flex', flexDirection: 'column' }}>
                        <div>
                            <span style={{ fontWeight: 600 }}>N1 - </span>{payment.email_n1} {payment.estatus === "NO AUTORIZADO" && payment.autorizado_n1 === 0 ? <WarningFilled style={{ color: "red" }} /> : null}
                        </div>
                        <div>
                            <span style={{ fontWeight: 600 }}>N2 - </span>{payment.email_n2} {payment.estatus === "NO AUTORIZADO" && payment.autorizado_n2 === 0 ? <WarningFilled style={{ color: "red" }} /> : null}
                        </div>
                    </div>
                </>
            )
        }
    ];

    const columnsToAuth = columns.concat([{
        title: 'Estatus',
        dataIndex: 'id_autorizacion',
        key: 'estatus',
        render: ((_, payment) =>
            <>
                <div
                    style={{ display: 'flex', justifyContent: 'center' }}>
                    <Tag icon={payment.autorizado_n1 === 1 ? <CheckCircleOutlined /> : <CloseCircleOutlined />} color={payment.autorizado_n1 === 1 ? 'green' : 'red'} key={payment.id_autorizacion}>
                        N1
                    </Tag>
                    <Tag icon={payment.autorizado_n2 === 1 ? <CheckCircleOutlined /> : <CloseCircleOutlined />} color={payment.autorizado_n2 === 1 ? 'green' : 'red'} key={payment.id}>
                        N2
                    </Tag>
                </div>
            </>
        )
    },
    {
        title: 'Acciones',
        dataIndex: 'id_autorizacion',
        key: 'actions',
        render: (_, payment) => {
            const decoded = jwtDecode(localStorage.getItem("token"));

            return (
                <>
                    {decoded && decoded.rol_id === 1 ? (
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                            <Button onClick={() => { setOpenDialog(true); setAuthInfo(payment); form.setFieldsValue({ emailn1: payment.email_n1 }); form.setFieldsValue({ emailn2: payment.email_n2 }); }}>
                                <EditOutlined />
                            </Button>
                            <Button
                                color="danger"
                                variant="filled"
                                onClick={() => {
                                    Modal.confirm({
                                        title: '¿Estás seguro de eliminar este control de pago?',
                                        content: `Se eliminará el control de pago "${payment.concepto}" de la lista`,
                                        okText: 'Sí, eliminar',
                                        cancelText: 'Cancelar',
                                        onOk: () => QuitPayment(payment)
                                    });
                                }}
                            >
                                Eliminar
                            </Button>
                        </div>
                    ) : <div style={{ textAlign: 'center' }}><MinusOutlined /></div>}
                </>
            )
        }

    }]);

    const columnsNotAuth = columns.concat({
        title: 'Notificado',
        dataIndex: 'viwed',
        key: 'visto',
        render: ((_, payment) =>
            <>
                <Button color="danger" variant="filled" onClick={() => QuitPayment(payment)}>Quitar </Button>
            </>
        )
    });

    const itemsTab = [{
        label: "Por autorizar",
        key: 1,
        children: <>
            <h3>Controles de Pago (Por Autorizar)</h3>
            <Table bordered style={{ marginTop: 30 }} columns={columnsToAuth} dataSource={list} />
        </>
    }, {
        label: "No Autorizado",
        key: 2,
        children: <>
            <h3>Controles de Pago (No Autorizados)</h3>
            <Table bordered style={{ marginTop: 30 }} columns={columnsNotAuth} dataSource={listNotAuth} />
        </>
    }];

    return (
        <>
            <Layout>
                <Content
                    className='primary-container'
                >
                    <Breadcrumb
                        className='breadcrumb'
                        items={[
                            { title: <a href="/home">Inicio</a> },
                            { title: "Control de Pagos (Por Autorizar/No Autorizados)" }
                        ]}
                    />

                    <Tabs
                        defaultActiveKey="1"
                        tabPosition={"left"}
                        style={{ marginTop: 30 }}
                        items={itemsTab}
                    />




                </Content>
            </Layout>
            <Modal
                title={`Correos para autorizar (${authInfo.concepto})`}
                open={openDialog}
                onCancel={() => setOpenDialog(false)}
                footer={null}
            >
                <Divider style={{ margin: '24px 0' }} />
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={handleUpdateAuth}
                >
                    <Form.Item
                        label="Correo electrónico (N1)"
                        name="emailn1"
                        rules={[{ required: true, message: 'Por favor ingresar el correo electrónico de N1' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Correo electrónico (N2)"
                        name="emailn2"
                        rules={[{ required: true, message: 'Por favor ingresar el correo electrónico de N2' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Divider style={{ margin: '24px 0' }} />
                    <Form.Item>
                        <div style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
                            <Button type="default" onClick={() => setOpenDialog(false)}>
                                Cancelar
                            </Button>
                            <Button type="primary" loading={loading} htmlType="submit">
                                Guardar
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default PaymentControlsToAuthorize;